module.exports = __webpack_public_path__ + "static/media/DiAttacks.1679b161.svg";